<template>
<svg width="22px" height="21px" viewBox="0 0 22 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="link_forward" transform="translate(-119.000000, -5.000000)" fill="currentColor">
            <g id="Actions-/-Navigation-/-arrow--left-/-16" transform="translate(118.000000, 4.000000)">
                <path d="M1.5,20.25 L22.5,20.25 L22.5,21.75 L1.5,21.75 L1.5,20.25 Z M19.0575,6.75 C19.3391656,6.46864761 19.49743,6.08686387 19.49743,5.68875 C19.49743,5.29063613 19.3391656,4.90885239 19.0575,4.6275 L16.3725,1.9425 C16.0911476,1.66083444 15.7093639,1.50257002 15.31125,1.50257002 C14.9131361,1.50257002 14.5313524,1.66083444 14.25,1.9425 L3,13.1925 L3,18 L7.8075,18 L19.0575,6.75 Z M15.3075,3 L18,5.6925 L15.75,7.9425 L13.0575,5.25 L15.3075,3 Z M4.5,16.5 L4.5,13.8075 L12,6.3075 L14.6925,9 L7.1925,16.5 L4.5,16.5 Z" id="Fill"></path>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
  name: 'Edit'
};
</script>
